import styled from 'styled-components';
import { Skeleton } from '#/shared/components/Skeletons/styled';

export const StopTopNameWrapper = styled.div`
  display: block;
  width: 100%;
`;

export const StopTopNameSkeleton = styled(Skeleton).attrs(props => ({
  borderRadius: '0.5rem',
  containerClassName: 'skeleton-flex',
  height: '0.9rem',
  baseColor: props.theme.stopTopSkeletonMain,
  highlightColor: props.theme.stopTopSkeletonHighlight,
}))``;
